// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"az_Zs","spin":"az__s","spinnerWrapper":"az_at","spinner":"az_bt"};